// extracted by mini-css-extract-plugin
export default {"notificationsList":"NotificationsPage_notificationsList__PRVr2","name":"NotificationsPage_name__sD7nD"};